/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { ZodTypes } from 'shared';

const ROLES = ZodTypes.RBAC.Organization.Roles.options;

export const useOrganizationRolesI18n = () => {
  const { t } = useTranslation();

  return useMemo(
    () =>
      ROLES.map(role => ({
        key: role,
        title: t(`rbac:organization.${role}.name.long`),
        description: <Trans i18nKey={`rbac:organization.${role}.description`} components={{ 1: <br /> }} />,
      })),
    [t],
  );
};
